/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Validator from "../../../utils/formValidator";
import action from "../../../action";
import axios from "axios";
import { api_config } from "../../../constants/api";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import rules from "../../../constants/rules";
import Utils from "../../../utils/utils";
import { ReactComponent as Comeback } from '../../../assets/icons/comback.svg'
export default function ForgetPassword(props) {
  const [loading, setLoading] = useState(false)
  const reducerData = useSelector((state) => state.userinfo);
  const lang = Utils.getLanguage();
  const [time, setTime] = useState(0);
  let second = 0;
  let timer;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation(["userLoginTips"]);
  const getCode = () => {
    let email = form.getFieldValue("email");
    if (rules.email.test(email)) {
      let formData = new FormData();
      formData.append("email", email);
      formData.append("is_validate", 1);
      axios({
        method: "POST",
        url: api_config.API_V2_URL + "accounts/verification-code",
        data: formData,
      })
        .then((obj) => {
          let res = obj.data;
          if (res.code === 200) {
            localStorage.setItem("forgetTime", new Date().getTime().toString());
            message.success(t("Ithasbeensenttoyourmailboxpleasecheckit"));
            localStorage.setItem("userResetEmail", email); //保存用户email
            localStorage.setItem("emailToken", res.data.token); //保存用户的验证码token
            waitTime();
            dispatch(action.sendVerification(res.data));
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 500) {
            message.error(t("500"));
          } else {
            switch (res.data.code) {
              case 404001:
                message.error(t("NoaccountfoundwiththatEmailaddress"));
                break;
              default:
                message.error(t("500"));
            }
          }
        });
    }
  };
  const comeback = () => {
    let email = form.getFieldValue("email");
    let code = form.getFieldValue("verificationCode");
    let obj = { email: email, code: code };
    props.keepAliveData(obj)
    props.changeStep(2)
  }
  const onSubmit = (value) => {
    setLoading(true)
    const { email, verificationCode } = value;
    let obj = { email: email, code: verificationCode };
    props.keepAliveData(obj)
    let formData = new FormData();
    formData.append("email", email);
    formData.append("code", verificationCode);
    formData.append(
      "token",
      reducerData.emailToken.token || localStorage.getItem("emailToken")
    );
    axios({
      method: "POST",
      url: api_config.API_V2_URL + "accounts/email-verify",
      data: formData,
    })
      .then((obj) => {
        setLoading(false)
        let res = obj.data;
        if (res.code === 200) {
          localStorage.setItem("verificationCode", verificationCode); //保存用户验证码
          dispatch(
            action.saveEmail({
              email: email,
              verificationCode: verificationCode,
            })
          );
          props.changeStep(5);
        }
      })
      .catch((err) => {
        setLoading(false)
        let res = err.response;
        switch (res.data.code) {
          case 400223:
            message.error(t("reg400223"));
            break;
          default:
            message.error(t("500"));
        }
      });
  };

  const renderBtn = () => {
    return time === 0 ? (
      <span className="text-primary" onClick={() => getCode()}>
        {t("GetCode")}
      </span>
    ) : (
      <span className="text-primary" style={{ cursor: "not-allowed" }}>
        {time} s
      </span>
    );
  };

  const waitTime = () => {
    let sendTime = localStorage.getItem("forgetTime");
    if (sendTime == null) {
      clearInterval(timer);
    } else {
      timer = setInterval(() => {
        if (second < 0) {
          localStorage.removeItem("forgetTime");
          clearTimeout(timer);
          second = 0;
          setTime(second);
        } else {
          second = (
            60 -
            (new Date().getTime() - parseInt(sendTime)) / 1000
          ).toFixed(0);
          setTime(second);
        }
      }, 1000);
    }
  };
  useEffect(() => {
    waitTime();
    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <div className="forgetPassword">
      <div>
        <Comeback onClick={comeback} className="comeback" />
        <div className="loginTitle"> {t("ForgotPassword2")}</div>
        <Form
          onFinish={onSubmit}
          layout="vertical"
          name="resetPassword"
          form={form}
        >
          <Form.Item
            name="email"
            className="formItem"
            validateTrigger="onBlur"
            initialValue={reducerData.keepAlive.email || ''}
            rules={[
              {
                validator: Validator.emailValidator,
              },
            ]}
            getValueFromEvent={(e) => {
              return e.target.value.replace(/\s+/g, "");
            }}
            label={
              <div className="verificationTitle">
                <div className="circle" />
                {t("Email")}
              </div>
            }
          >
            <Input placeholder={t("Email")} className="inputForm" />
          </Form.Item>
          <Form.Item
            name="verificationCode"
            className="formItem"
            validateTrigger="onBlur"
            initialValue={reducerData.keepAlive.code || ''}
            rules={[
              {
                validator: Validator.emptyValidator,
              },
            ]}
            getValueFromEvent={(e) => {
              return e.target.value.replace(/\s+/g, "");
            }}
            label={
              <div className="verificationTitle">
                <div className="circle" />
                {t("Verificationcode")}
              </div>
            }
          >
            <Input
              addonAfter={renderBtn()}

              className={
                lang === "ar" ? "verificationInputAr" : "verificationInput"
              }
              placeholder={t("Verificationcode")}
            />
          </Form.Item>
          <Form.Item>
            <Button loading={loading} className="confirmBtn" type="primary" htmlType="submit">
              {t("VerifyEmail")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
